var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "act_right",
    d: "M2.09917 0.849785L2.09919 0.849806L6.14743 4.90648C6.14749 4.90654 6.14755 4.9066 6.1476 4.90665C6.75047 5.50971 6.75038 6.49026 6.14741 7.09353L2.09917 0.849785ZM2.09917 0.849785C1.80048 0.550515 1.31574 0.55 1.01645 0.848675L2.09917 0.849785ZM1.0153 1.93144L1.01529 1.93143C0.716652 1.63214 0.717115 1.1474 1.01642 0.848709L1.0153 1.93144ZM1.0153 1.93144L5.06411 5.98868L5.06439 5.98896M1.0153 1.93144L5.06439 5.98896M5.06439 5.98896C5.06621 5.99078 5.06705 5.99227 5.0676 5.99362C5.06825 5.99523 5.06874 5.99738 5.06874 5.9999C5.06874 6.00242 5.06825 6.00463 5.06756 6.00632C5.06698 6.00776 5.06606 6.00937 5.06409 6.01134L5.06382 6.01162M5.06439 5.98896L5.06382 6.01162M5.06382 6.01162L1.0153 10.0686L1.01529 10.0686M5.06382 6.01162L1.01529 10.0686M1.01529 10.0686C0.716657 10.3679 0.717115 10.8526 1.0164 11.1513L1.01529 10.0686ZM2.09919 11.1502L6.14714 7.0938L1.01645 11.1513C1.16585 11.3004 1.36223 11.375 1.55725 11.375C1.75287 11.375 1.94971 11.3 2.09919 11.1502L1.83375 10.8853L2.09919 11.1502Z",
    fill: "#1E3799",
    stroke: "#1E3799",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActRight);
export default __webpack_public_path__ + "static/media/act_right.1c4604516008ed7c88fb28cc088bf8ab.svg";
export { ForwardRef as ReactComponent };